import React from 'react';
import { useTranslation } from 'react-i18next';
import { fmtNum } from './helpers';

/**
 * Статистическая панель — шесть KPI-карточек. Все значения из summary, клиент ничего
 * не пересчитывает. При пустой выборке summary приходит с нулями — карточки показывают 0.
 */
export default function StatisticsPanel({ summary }) {
  const { t, i18n } = useTranslation();
  const s = summary || {};
  const n = (v) => fmtNum(v ?? 0, i18n.language);

  const cards = [
    { cls: 'total', num: n(s.total), lbl: t('schools.kTotal') },
    { cls: 'good', num: n(s.good), lbl: t('schools.kGood') },
    { cls: 'bad', num: n(s.bad), lbl: t('schools.kBad') },
    { cls: 'brand', num: n(s.students_total), lbl: t('schools.kStudents') },
    { cls: 'total', num: n(s.capacity_total), lbl: t('schools.kCap') },
    { cls: 'bad', num: n(s.deficit_total), lbl: t('schools.kDeficit') },
  ];

  return (
    <div className="sch-kpis">
      {cards.map((c, i) => (
        <div className={`sch-kpi ${c.cls}`} key={i}>
          <div className="num">{c.num}</div>
          <div className="lbl">{c.lbl}</div>
        </div>
      ))}
    </div>
  );
}
